import { ISuggestProps } from './types';
import React, { useEffect, useState } from 'react';
import { Suggest } from './index';
import { mapEnToRu } from '../../../../helpers';

type IIssuedSuggestProps<T> = Pick<ISuggestProps<T>, 'input' | 'onBlur' | 'onChange' | 'onFocus' | 'onSelect'> & {
    options: string[];
};

export const IssuedSuggest = (props: IIssuedSuggestProps<string>) => {
    const { options, onChange = () => null } = props;
    const [optionsList, setOptionsList] = useState<string[]>([]);

    useEffect(() => {
        setOptionsList(options);
    }, [options]);

    const onChangeHandler: typeof props['onChange'] = (event) => {
        const {
            target: { value },
        } = event;
        const transpiledValue = mapEnToRu(value);
        event.target.value = transpiledValue;
        const filteredOptions = transpiledValue
            ? options.filter((item) => item.toLowerCase().includes(transpiledValue.toLowerCase()))
            : options;
        setOptionsList(filteredOptions);
        onChange(event);
    };

    return (
        <Suggest<string>
            {...props}
            options={optionsList}
            onlyList={false}
            menuWithoutValue
            onChange={onChangeHandler}
            mapperOption={(option) => ({ name: option, value: option, option })}
        />
    );
};
